
<template>
  <v-container fluid grid-list-xl page>

    <!-- Your contet -->

    <div class="display-3 grey--text text--darken-1">Product Features</div>
    <div
      class="title grey--text text--darken-1"
    ></div>

    <v-layout>
      <v-flex>
        <v-card class="justify-center">
          <v-container fluid grid-list-md>
            <v-layout row wrap class="justify-center">
              <v-flex xs12 md6 lg3 offset-2>
                <v-card flat tile>
                  <v-img justify-center src="/static/send.png" width="100" aspect-ratio="1"></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">Ready for Integration</h3>
                      <div> API integrable solutions with access to real-time information. Integration can be performed at back-end or front-end level.</div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img src="/static/digital-signature.png" width="100" aspect-ratio="1"></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Customizable</h3>
                      <div>You can choose your desired components:  ID OCR, facial matching, digital signature by OTP or digital certificate.</div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img s src="/static/2devices.png" width="100" aspect-ratio="1"></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Omnichannel and Omnidevice</h3>
                      <div>Sign on any device (mobile, tablet or PC), in person or remote, maintaining maximum guarantees.</div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>





            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>


<v-layout height="100" >
  <v-card height="100" flat color="grey">
  </v-card>
</v-layout>

    <v-layout>
      <v-flex>
        <v-card class="justify-center">
          <v-container fluid grid-list-md>
            <v-layout row wrap class="justify-center">
              <v-flex xs12 md6 lg3 offset-2>
                <v-card flat tile>
                  <v-img justify-center src="/static/ui.png" width="100" aspect-ratio="1"></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">Optimized UX Design</h3>
                      <div>Usability designed products: maximum functionality, in minimum steps, maintaining legal requirements.</div>
                    </div>
                  </v-card-title>

                  <v-card-actions>

                  </v-card-actions>
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img src="/static/transparencia.png" width="100" aspect-ratio="1"></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Transparency</h3>
                      <div>Our solutions have an updated back-office tool in real time, with automated and customizable business rules control.</div>
                    </div>
                  </v-card-title>

                  <v-card-actions>

                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img s src="/static/legal.png" width="100" aspect-ratio="1"></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">With full legal validity</h3>
                      <div>Securyty´s electronic signatures comply with legal requirements in the EU and in the USA. Additionally, when signing an audit trail is generated with an official time stamp.</div>
                    </div>
                  </v-card-title>

                  <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange" @click="goToLegal">Learn More</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>        
    <v-dialog v-model="isCreateSign" persistent max-width="500px" >
      <v-card>
        <v-toolbar color="orange" dark>
          <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
          <v-toolbar-title>Create New Identification </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip right>
            <v-icon
                slot="activator"
                color="white"
                dark
              >help_outline</v-icon>
            <span><b>Identity Verification : <br><br>- Identify through a video, view the result and sign a document with the data extracted from the identification</b><br><br>
            </span>
          </v-tooltip>
        </v-toolbar>
        <create-sign-video-page :scrollTop=scrollTop signatureType="video"></create-sign-video-page>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"  @click.native="closeSignaturePage">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
  </v-container>
</template>

<script>
import CreateSignVideoPage from "./CreateSignVideoPage";

export default {
  components: {
    CreateSignVideoPage
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      isCreateSign: false,
      page: {
        title: "Key Features ",
        headline: "Key Features",
        description: `Automate your on-boarding process`
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ],
      scrollTop: 0
    };
  },
  methods: {
    createSignature() {
      //this.$router.push("CreateSignPage")
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.getElementsByTagName("body")[0].className = "noscroll";
      this.isCreateSign = true;
    },
    closeSignaturePage() {
      document.body.removeAttribute("class", "noscroll");
      window.scrollTo(0, this.scrollTop);
      this.isCreateSign = false;
    },
    goToLegal() {
      this.$router.push({ name: "legalInformation" });
    }
  }
};
</script>
